import React from "react";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { CreateAlerts } from '../../REST/alert';
import useEditor from "../../Utils/rte";
import WorkflowDialogShell from '../../themes/components/WorkflowDialogShell';

export default function MessageDialog({ open, handleClose, title, userIds = [], body, Extraheader }) {
    const [subject, setSubject] = React.useState(title);
    const [sending, setSending] = React.useState(false);
    const [Editor, getHtml] = useEditor(body);

    React.useEffect(() => {
        setSubject(title);
    }, [title, open]);

    const handleSend = async () => {
        const htmlBody = getHtml();
        if (subject.trim() === '' || htmlBody == null || userIds.length === 0) return;

        setSending(true);
        try {
            await CreateAlerts({ userIds, subject, body: htmlBody });
            handleClose();
        } finally {
            setSending(false);
        }
    };

    if (userIds.length === 0) return <></>;

    return (
        <WorkflowDialogShell
            open={open}
            onClose={handleClose}
            onSave={handleSend}
            title={title || 'Send Alert'}
            saveLabel={sending ? 'Sending...' : 'Send'}
            saveDisabled={sending}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {Extraheader && (
                    <Box>
                        <Extraheader />
                    </Box>
                )}
                <Typography variant="body2" color="text.secondary">
                    Compose your message and send it to the selected recipients.
                </Typography>
                <TextField
                    value={subject}
                    onChange={(evt) => setSubject(evt.target.value)}
                    margin='dense'
                    label='Subject'
                    fullWidth
                    variant="standard"
                />
                <Editor />
            </Box>
        </WorkflowDialogShell>
    );
}
